import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { motion } from "framer-motion";
import img1 from "../assets/TestimonialImg/img1.jpg";
import img2 from "../assets/TestimonialImg/img2.jpg";
import img3 from "../assets/TestimonialImg/img3.avif";
import img4 from "../assets/TestimonialImg/img4.jpg";
import img5 from "../assets/TestimonialImg/img5.jpg";

const testimonials = [
  {
    name: "President, ClearTone Consulting",
    text: "BetterWorld Technology is the best MSP I've come across. They are responsive, responsible, thorough, and transparent.",
    avatar: img1,
  },
  {
    name: "Operations Manager, Arch Support",
    text: "We met regularly to address any issues and concerns, and they came up with solutions to overcome these hurdles.",
    avatar: img2,
  },
  {
    name: "Director, Entrepreneurs Across Borders",
    text: "They've nailed all goals, timelines, and communications.",
    avatar: img3,
  },
  {
    name: "CEO, Clark Brands, LLC",
    text: "The workflow is collaborative, effective, and timely.",
    avatar: img4,
  },
  {
    name: "IT Ops Manager, OMI Industries INC",
    text: "Never had a late project thanks to the speed BetterWorld Technology provides to our company.",
    avatar: img5,
  },
];

export default function TestimonialSlider() {
  const [index, setIndex] = useState(0);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const total = testimonials.length;

  const next = () => setIndex((prev) => (prev + 1) % total);
  const prev = () => setIndex((prev) => (prev - 1 + total) % total);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => next(), 7000);
    return () => clearTimeout(timeoutRef.current!);
  }, [index]);

  const getVisibleTestimonials = () => {
    const visible = [];
    for (let i = 0; i < 3; i++) {
      visible.push(testimonials[(index + i) % total]);
    }
    return visible;
  };

  return (
    <section className="bg-blue-900 text-white py-20 px-4 md:px-16 relative overflow-hidden">
      <h2 className="text-center text-4xl font-bold text-white mb-12">
        What <span className="text-orange-400">Our Clients</span> Say
      </h2>

      {/* Arrows */}
      <div className="absolute top-1/2 left-6 -translate-y-1/2 z-10">
        <button
          onClick={prev}
          className="bg-white p-2 rounded-full shadow-lg hover:bg-gray-200 transition"
        >
          <ChevronLeft className="text-blue-900" />
        </button>
      </div>
      <div className="absolute top-1/2 right-6 -translate-y-1/2 z-10">
        <button
          onClick={next}
          className="bg-white p-2 rounded-full shadow-lg hover:bg-gray-200 transition"
        >
          <ChevronRight className="text-blue-900" />
        </button>
      </div>

      <div className="flex justify-center">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl w-full">
          {getVisibleTestimonials().map((testimonial, i) => (
            <motion.div
              key={testimonial.name + i}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              className="bg-white text-gray-800 rounded-xl p-6 shadow-xl flex flex-col items-center text-center"
            >
              <img
                src={testimonial.avatar}
                alt={testimonial.name}
                className="w-16 h-16 rounded-full mb-4 object-cover"
              />
              <p className="text-base italic mb-4">{testimonial.text}</p>
              <p className="text-blue-900 font-semibold text-sm">
                {testimonial.name}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
